var PricingDetails = /** @class */ (function () {
    function PricingDetails(Pricing, PricingNumbersService, LiveChatService, Toast, $location, Router) {
        this.Pricing = Pricing;
        this.PricingNumbersService = PricingNumbersService;
        this.LiveChatService = LiveChatService;
        this.toast = Toast;
        this.$location = $location;
        this.router = Router;
    }
    PricingDetails.prototype.$onInit = function () {
        this.numbersPricings = this.PricingNumbersService.query({ code: this.country.iso2.toUpperCase() });
        this.prices = this.Pricing.prices({ code: this.country.iso2 });
    };
    PricingDetails.prototype.send = function () {
        var isoCode = this.country.iso2.toLocaleUpperCase();
        this.router.navigateByUrl("/get-new-number/pricing/" + isoCode);
    };
    PricingDetails.prototype.contactSupport = function () {
        this.LiveChatService.contactSupport();
    };
    PricingDetails.$inject = ['Pricing', 'PricingNumbersService', 'LiveChatService', 'Toast', '$location', 'Router'];
    return PricingDetails;
}());
export default {
    controller: PricingDetails,
    template: require('./pricing.details.html'),
    bindings: { country: "<", hide: '&' }
};
//# sourceMappingURL=pricing.details.js.map